/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Engagement_ThanksInputs */

const en_us2_engagement_thanks = /** @type {(inputs: Engagement_ThanksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thanks for telling us.`)
};

const pt_br2_engagement_thanks = /** @type {(inputs: Engagement_ThanksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obrigado por contar pra gente.`)
};

const es_419_engagement_thanks = /** @type {(inputs: Engagement_ThanksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gracias por contarnos.`)
};

const pt_pt2_engagement_thanks = /** @type {(inputs: Engagement_ThanksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obrigado por nos contares.`)
};

const fr_fr2_engagement_thanks = /** @type {(inputs: Engagement_ThanksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merci de nous l'avoir dit.`)
};

const de_de2_engagement_thanks = /** @type {(inputs: Engagement_ThanksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danke, dass du es uns sagst.`)
};

const it_it2_engagement_thanks = /** @type {(inputs: Engagement_ThanksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grazie per avercelo detto.`)
};

/**
* | output |
* | --- |
* | "Thanks for telling us." |
*
* @param {Engagement_ThanksInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const engagement_thanks = /** @type {((inputs?: Engagement_ThanksInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Engagement_ThanksInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_engagement_thanks(inputs)
	if (locale === "es-419") return es_419_engagement_thanks(inputs)
	if (locale === "pt-PT") return pt_pt2_engagement_thanks(inputs)
	if (locale === "fr-FR") return fr_fr2_engagement_thanks(inputs)
	if (locale === "de-DE") return de_de2_engagement_thanks(inputs)
	if (locale === "it-IT") return it_it2_engagement_thanks(inputs)
	return en_us2_engagement_thanks(inputs)
});
export { engagement_thanks as "engagement.thanks" }